export const KEYS_ENTER = 'Enter'
export const KEYS_ESCAPE = 'Escape'
export const KEYS_ARROW_UP = 'ArrowUp'
export const KEYS_ARROW_DOWN = 'ArrowDown'



// WEBPACK FOOTER //
// ./src/constants/keyboardKeys.js